import PropTypes from 'prop-types';
import React from 'react';
import DropdownMenu from 'react-dd-menu';
import { connect } from 'react-redux';
import DropdownCaret from 'components/menu/DropdownCaret';
import { MenuAction } from 'components/menu/MenuItems';
import { MenuLink } from 'components/menu/MenuItems';
// import 'react-dd-menu/dist/react-dd-menu.min.css'

class HelpMenu extends React.Component {
    static propTypes = {
        isLarge: PropTypes.bool,
    };

    state = { isMenuOpen: false };

    toggleMenu = () => {
        this.setState({ isMenuOpen: !this.state.isMenuOpen });
    };

    closeMenu = () => {
        this.setState({ isMenuOpen: false });
    };

    handleSupportClick = () => {
        if (window.zE) {
            // Show Zendesk Contact Us dialog
            window.zE.activate();
        }
        this.toggleMenu();
    };

    renderButton = () => {
        const { isLarge } = this.props;
        const { isMenuOpen } = this.state;
        return (
            <span
                style={{
                    // TODO (Nicholas): Use recompose to share this menu background behavior
                    backgroundColor: isMenuOpen
                        ? '#00A7E4'
                        : 'rgba(0, 0, 0, 0)',
                    paddingLeft: '7px',
                    paddingRight: '6px', // When 'Help' is Hidden
                    cursor: 'pointer',
                    // TODO (Nicholas): keep in sync with topbar height, or fix 100%
                    height: '50px',
                    display: 'flex',
                    alignItems: 'flex-end',
                    paddingBottom: '14px',
                    color: '#fff',
                    fontSize: '14px',
                    fontWeight: 400,
                }}
                onClick={this.toggleMenu}
            >
                <i
                    className="fa-regular fa-question-circle"
                    size="lg"
                    style={{
                        paddingRight: isLarge ? '5px' : '0px',
                        paddingLeft: '6px',
                        transform: 'translateY(-2px)',
                    }}
                />
                {isLarge && 'Help'}
                <DropdownCaret />
            </span>
        );
    };

    render() {
        const paddingRight = '12px';
        const iconPadding = { paddingRight };
        return (
            <DropdownMenu
                align="right"
                menuAlign="right"
                animate={false}
                isOpen={this.state.isMenuOpen}
                toggle={this.renderButton()}
                close={this.closeMenu}
            >
                <MenuLink
                    to="https://support.waypointbuilding.com/hc/en-us"
                    external={true}
                >
                    <i
                        className="fa-solid fa-external-link"
                        style={iconPadding}
                    />
                    Visit Help Center
                </MenuLink>
                <MenuAction onClick={this.handleSupportClick}>
                    <i className="fa-solid fa-envelope" style={iconPadding} />
                    Contact Support
                </MenuAction>
            </DropdownMenu>
        );
    }
}

export default connect((state) => {
    return { isLarge: state.browser.mediaType === 'lg' };
})(HelpMenu);
